export const NOTICE_TYPE_REQUEST = 'NOTICE_TYPE_REQUEST';
export const NOTICE_TYPE_SUCCESS = 'NOTICE_TYPE_SUCCESS';
export const NOTICE_TYPE_FAIL = 'NOTICE_TYPE_FAIL';

